export default __webpack_public_path__ + "static/media/smart-setup-360devpro.478dbac6.svg";